import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import { vars, mixin, css, classNames } from '@src/services/theme';

// typing
interface Props {
	className?: string;
    value: number;
    min?: number;
    max?: number;
    bands?: {
        min: number,
        max: number,
        color: string
    }[]
}

// style
const style = css`
    width: 130px;
	height: 120px;
    margin: 0 auto;
	overflow: hidden;
`;

// component
export default class Gauge extends React.Component<Props> {

	render() {
        const { className, value, min = 0, max = 100, bands = [] as any } = this.props;
        
        let _bands = bands.map( b => ({
            "color": b.color,
            "endValue": b.max,
            "startValue": b.min,
            "innerRadius": "50%",
        }));
        if (_bands.length === 0) {
            _bands = [{
                color: vars.colors.green,
                startValue: min,
                endValue: max,
                innerRadius: "50%"
            }];
        }
        
        /*
		let color = vars.colors.red;
		if (value > 30) color = vars.colors.yellow;
        if (value > 75) color = vars.colors.green;
        */

        const opts = {
            "type": "gauge",
            "theme": "light",
            "axes": [ {
              "axisThickness": 0,
              "axisAlpha": 0,
              "tickAlpha": 0,
              "valueInterval": 20,
              "labelsEnabled": false,
              "bands": _bands,
              "radius": "100%",
              "startValue": min,
              "endValue": max,
              /*"bottomText": `${value}`,
              "bottomTextFontSize": 20,
              "bottomTextYOffset": 0,*/
            }],
            "arrows": [ {
                "radius": "50%",
                "innerRadius": 0,
                "clockWiseOnly": true,
                "nailRadius": 5,
                "startWidth": 5,
                "nailAlpha": 1,
                "value": value
            }],
            labelsEnabled: false,
            autoMargins: false,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            pullOutRadius: 0,

        };

		return (
			<div
				className={classNames(
					style,
					className,
				)}
			>
				<AmCharts.React style={{ width: "100%", height: "120px" }} options={opts} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/UI/Gauge2.tsx